import React from 'react';
import type { DashboardProject } from '../../project/types/project';
import { PipeFilter, PipeDetailsSelectionItem } from './PipeFilter';

interface PipeDetailsProps {
  project: DashboardProject;
  canEdit?: boolean;
  canReport?: boolean;
  selectedPipe?: any;
  onSelectionChange?: (details: PipeDetailsSelectionItem[]) => void;
  pipeSizesData?: any[];
}

export const PipeDetails: React.FC<PipeDetailsProps> = ({
  project,
  canEdit,
  canReport,
  selectedPipe,
  onSelectionChange,
  pipeSizesData = [],
}) => {
  return (
    <div className="space-y-4">
      <PipeFilter
        project={project}
        canEdit={canEdit}
        canReport={canReport}
        selectedPipe={selectedPipe}
        onSelectionChange={onSelectionChange}
        pipeSizesData={pipeSizesData}
      />
    </div>
  );
};
